import '~/utils/extensions'
import '~/utils/dates/plugins/'
import { useLoadRuntimeCfg } from '~/services/runtimeCfg'

export default defineNuxtPlugin(() => {
  // this will avoid cfg to be empty when using it in other modules
  useLoadRuntimeCfg()
})
